import { render, staticRenderFns } from "./ProfilePageEmail.vue?vue&type=template&id=6629fa5e&"
import script from "./ProfilePageEmail.vue?vue&type=script&lang=js&"
export * from "./ProfilePageEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports